// extracted by mini-css-extract-plugin
module.exports = {"get10X":"Store_get10X__2T9Sp","root":"Store_root__3tEv-","main":"Store_main__2q106","item":"Store_item__1YbvF","load":"Store_load__1n-0A"};